export const BRANCHES_ERROR = 'BRANCHES_ERROR'
export const BRANCHES_SUCCESS = 'BRANCHES_SUCCESS'
export const BRANCHES_LOADING = 'BRANCHES_LOADING'
export const HEALTHCARE_PROVIDERS_ERROR = 'HEALTHCARE_PROVIDERS_ERROR'
export const HEALTHCARE_PROVIDERS_SUCCESS = 'HEALTHCARE_PROVIDERS_SUCCESS'
export const HEALTHCARE_PROVIDERS_LOADING = 'HEALTHCARE_PROVIDERS_LOADING'
export const RIPS_HISTORY_ERROR = 'RIPS_HISTORY_ERROR'
export const RIPS_HISTORY_SUCCESS = 'RIPS_HISTORY_SUCCESS'
export const RIPS_HISTORY_LOADING = 'RIPS_HISTORY_LOADING'
export const RIPS_CONTENT_CLEAR = 'RIPS_CONTENT_CLEAR'
export const FILTER_SUCCESS='FILTER_SUCCESS'
export const FILTER_CLEAR='FILTER_CLEAR'
export const DOWNLOAD_FILES_LOADING='DOWNLOAD_FILES_LOADING'
export const DOWNLOAD_FILES_ERROR='DOWNLOAD_FILES_ERROR'